var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoveTop = function SvgMoveTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.05h9c.276 0 .5-.235.5-.525a.517.517 0 0 0-.432-.52L14.5 3h-9c-.276 0-.5.235-.5.525 0 .266.188.485.432.52l.068.005Zm4.423 12.945.078.005a.68.68 0 0 0 .662-.618l.005-.082V7.49l2.196 2.304c.24.252.618.271.88.058l.063-.059a.726.726 0 0 0 .055-.923l-.055-.066-3.332-3.497a.644.644 0 0 0-.88-.059l-.063.059-3.336 3.496a.725.725 0 0 0 0 .99c.24.253.618.272.88.059l.062-.058 2.196-2.301V16.3c0 .36.257.655.589.695Z",
    fill: "#666"
  })));
};
export default SvgMoveTop;